import ActionTypes from '../../constants/ActionTypes';
import common from '../_common/actions'; // ============ creators ===========

var setActiveKey = common.setActiveKey(ActionTypes.ATTRIBUTE_SETS);
var setActiveKeys = common.setActiveKeys(ActionTypes.ATTRIBUTE_SETS); // ============ export ===========

export default {
  setActiveKey: setActiveKey,
  setActiveKeys: setActiveKeys
};